module.exports = __webpack_public_path__ + "img/privacy.294e381f.svg";